// Control action types
export const FETCH_CONTROLS_START = 'FETCH_CONTROLS_START';
export const FETCH_CONTROLS_SUCCESS = 'FETCH_CONTROLS_SUCCESS';
export const FETCH_CONTROLS_ERROR = 'FETCH_CONTROLS_ERROR';
export const EDIT_CONTROL = 'EDIT_CONTROL';
export const EDIT_GENERATED_CONTROL = 'EDIT_GENERATED_CONTROL';
export const DISCARD_CONTROL = 'DISCARD_CONTROL';
export const ADD_RISK_TO_FETCHED = 'ADD_RISK_TO_FETCHED';
export const REMOVE_RISK_FROM_FETCHED = 'REMOVE_RISK_FROM_FETCHED';
export const FETCH_CONTROLS_PER_RISK='FETCH_CONTROLS_PER_RISK'
export const UPDATE_CONTROL_EVALUATION_FIELD = 'UPDATE_CONTROL_EVALUATION_FIELD';
export const SET_SAVED_CONTROLS_START = 'FETCH_SAVED_CONTROLS_START';
export const SET_SAVED_CONTROLS_SUCCESS = 'FETCH_SAVED_CONTROLS_SUCCESS';
export const SET_SAVED_CONTROLS_ERROR = 'FETCH_SAVED_CONTROLS_ERROR';
export const FETCH_SAVED_CONTROL_EVALUATIONS_START='FETCH_SAVED_CONTROL_EVALUATIONS_START'
export const FETCH_SAVED_CONTROL_EVALUATIONS_SUCCESS='FETCH_SAVED_CONTROL_EVALUATIONS_SUCCES'
export const FETCH_SAVED_CONTROL_EVALUATIONS_ERROR='FETCH_SAVED_CONTROL_EVALUATIONS_ERROR'
export const SAVE_CONTROL_START   = 'SAVE_CONTROL_START';
export const SAVE_CONTROL_SUCCESS = 'SAVE_CONTROL_SUCCESS';
export const SAVE_CONTROL_ERROR   = 'SAVE_CONTROL_ERROR';
export const ADD_SAVED_CONTROL = 'ADD_SAVED_CONTROL';
export const SET_FETCHING_CONTROLS_STATUS = 'SET_FETCHING_CONTROLS_STATUS';
export const DISCARD_SAVED_CONTROL='DISCARD_SAVED_CONTROL'
export const UPDATE_SAVED_CONTROL_EVALUATION_FIELD = 'UPDATE_SAVED_CONTROL_EVALUATION_FIELD';
export const RESET_CONTROLS_STATE = 'RESET_CONTROLS_STATE';
export const REFRESH_CONTROLS_START ='REFRESH_CONTROLS_START';
export const REFRESH_CONTROLS_SUCCESS='REFRESH_CONTROLS_SUCCESS'
export const REFRESH_CONTROLS_ERROR='REFRESH_CONTROLS_ERROR'
export const EDIT_SAVED_CONTROL = 'EDIT_SAVED_CONTROL';
export const FETCH_ACTIONPLAN_START   = 'FETCH_ACTIONPLAN_START';
export const FETCH_ACTIONPLAN_SUCCESS = 'FETCH_ACTIONPLAN_SUCCESS ';
export const FETCH_ACTIONPLAN_ERROR   = 'FETCH_ACTIONPLAN_ERROR';
export const EDIT_GENERATED_ACTIONPLAN_ROW='EDIT_GENERATED_ACTIONPLAN_ROW'
export const EDIT_SAVED_ACTIONPLAN_ROW='EDIT_SAVED_ACTIONPLAN_ROW'


export const resetControlsState = () => ({
  type: RESET_CONTROLS_STATE
});
  

export const fetchControls = ({ sectionName, narratives,riskSourceData, sectionRisks, controlModelType,
  controlModelStage}) => async (dispatch) => {
  dispatch({type: FETCH_CONTROLS_START});

  try {
    const controlsPromises = sectionRisks.map(async (risk) => {
      const { name: riskSourceName, value: riskSourceValue, causes } = riskSourceData;

      const response = await fetch('/.netlify/functions/generateActionsByRisk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sectionName,
          riskSourceData: {
            name: riskSourceName,
            value: riskSourceValue,
            causes: causes
          },
          riskName: risk.riskName,
          riskId: risk.riskId,
          narratives,
          controlModelType,
          controlModelStage,
          //controlPreviousStage
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch controls for risk: ${risk.riskName}`);
      }

      const controls = await response.json();
      return { riskId: risk.riskId, controls };
    });

    const results = await Promise.all(controlsPromises);

    const controlsMap = results.reduce((acc, { riskId, controls }) => {
      acc[riskId] = controls;
      return acc;
    }, {});

    dispatch({ type: FETCH_CONTROLS_SUCCESS, payload: controlsMap });
  } catch (error) {
    dispatch({ type: FETCH_CONTROLS_ERROR, payload: error.message });
  }
};

export const refreshSingleRiskControls = (sectionName, sectionState, riskName, riskId) => async (dispatch) => {
 

  dispatch({
    type: REFRESH_CONTROLS_START,
    payload: { riskId }
  });

  try {
    const response = await fetch('/.netlify/functions/generateControls', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sectionName, sectionState, riskName, riskId })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const controls = await response.json();
    const newControls = {
      [riskId]: controls
    };

    dispatch({
      type: REFRESH_CONTROLS_SUCCESS,
      payload: newControls
    });
  } catch (error) {
    dispatch({
      type: REFRESH_CONTROLS_ERROR,
      payload: error.message
    });
  }
};


export const updateControlEvaluationField = (riskId, controlId, fieldName, value) => ({
  type: UPDATE_CONTROL_EVALUATION_FIELD,
  payload: { riskId, controlId, fieldName, value }
});

// In your actions file
export const updateSavedControlEvaluationField = (riskId, controlId, fieldName, value) => ({
  type: UPDATE_SAVED_CONTROL_EVALUATION_FIELD,
  payload: { riskId, controlId, fieldName, value },
});



  
export const editControl = (controlData, index, riskId) => ({
  type: EDIT_CONTROL,
  payload: { controlData, index, riskId },
});

export const editGeneratedControl = (riskId, controlId, newName) => ({
  type: EDIT_GENERATED_CONTROL,
  payload: { riskId, controlId, newName },
});
export const editSavedControl = (riskId, controlId, newName) => ({
  type: EDIT_SAVED_CONTROL,
  payload: { riskId, controlId, newName },
});


export const editGeneratedActionPlanRow = (controlId, newName) => ({
  type: EDIT_GENERATED_ACTIONPLAN_ROW,
  payload: { controlId, newName },
});

export const editSavedActionPlanRow = (controlId, newName) => ({
  type: EDIT_SAVED_ACTIONPLAN_ROW,
  payload: { controlId, newName },
});
  
  export const discardControl = (control, riskId) => ({
    type: DISCARD_CONTROL,
    payload: { ...control, riskId }
  });
  export const addRiskToFetched = (riskId) => ({
    type: ADD_RISK_TO_FETCHED,
    payload: riskId
  });
  
  export const removeRiskFromFetched = (riskId) => ({
    type: REMOVE_RISK_FROM_FETCHED,
    payload: riskId
  });

  export const setSavedControls = (modelId, assessmentUuid) => async (dispatch) => {
    dispatch({ type: SET_SAVED_CONTROLS_START });
  
    try {
      const response = await fetch('/.netlify/functions/fetchSavedControls', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ modelId, assessmentUuid })
      });
  
      if (!response.ok) throw new Error('Failed to fetch saved controls');
  
      const savedControls = await response.json();
    console.log ('savedcontrols sent to reducer', savedControls)
      dispatch({
        type: SET_SAVED_CONTROLS_SUCCESS,
        payload: savedControls,
        meta   : { modelId } 
      });
    } catch (error) {
      dispatch({
        type: SET_SAVED_CONTROLS_ERROR,
        payload: error.message
      });
    }
  };

  export const fetchSavedControlEvaluations = (modelId, assessmentUuid) => async (dispatch) => {
    dispatch(fetchSavedControlEvaluationsStart());
  
    try {
      const response = await fetch('/.netlify/functions/fetchSavedControlEvaluations', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ modelId, assessmentUuid }),
      });
  
      if (!response.ok) throw new Error('Failed to fetch saved control evaluations');
  
      const savedControlEvaluations = await response.json();
      dispatch(fetchSavedControlEvaluationsSuccess(savedControlEvaluations));
    } catch (error) {
      dispatch(fetchSavedControlEvaluationsError(error.message));
    }
  };
  
  export const fetchSavedControlEvaluationsStart = () => ({
    type: FETCH_SAVED_CONTROL_EVALUATIONS_START,
  });
  
  export const fetchSavedControlEvaluationsSuccess = (savedControlEvaluations) => ({
    type: FETCH_SAVED_CONTROL_EVALUATIONS_SUCCESS,
    payload: savedControlEvaluations,
  });
  
  export const fetchSavedControlEvaluationsError = (error) => ({
    type: FETCH_SAVED_CONTROL_EVALUATIONS_ERROR,
    payload: error,
  });
  export const saveControl = ({
    risk,
    control,
    modelId,
    assessmentUuid,
    controlModelType,
    controlModelStage
  }) => async (dispatch) => {
    // 1) kick off spinner in state
    dispatch({ type: SAVE_CONTROL_START, payload: control.controlId });
  
    try {
      // 2) POST to Netlify function
      const response = await fetch('/.netlify/functions/saveControl', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          modelUuid:         modelId,
          assessmentUuid,
          riskIds:           control.riskIds || [risk.riskId],
          controlName:       control.name,
          controlModelType,
          controlModelStage,
          controlUuid:       control.controlId,
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to save control');
      }
      await response.json();
  
      // 3) update Redux state
      dispatch(addSavedControl({
        ...control,
        status:  'saved',
        riskIds: control.riskIds || [risk.riskId],
        modelId,
      }));
      dispatch({ type: SAVE_CONTROL_SUCCESS, payload: control.controlId });
    } catch (error) {
      dispatch({
        type: SAVE_CONTROL_ERROR,
        payload: { controlId: control.controlId, error: error.message }
      });
      throw error;
    }
  };


export const addSavedControl = (control) => ({
  type: ADD_SAVED_CONTROL,
  payload: control          // exactly what UI passed
});

export const setFetchingControlsStatus = (riskId, isFetching) => ({
  type: SET_FETCHING_CONTROLS_STATUS,
  payload: { riskId, isFetching },
});


export const discardSavedControl = (control, riskId) => async dispatch => {
  try {
    // Call serverless function to delete the control from the database
    const response = await fetch('/.netlify/functions/discardControl', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ controlId: control.controlId })
    });

    if (!response.ok) {
      throw new Error('Failed to delete the control');
    }

    // Dispatch an action to remove the control from Redux state
    dispatch({
            type   : 'DISCARD_SAVED_CONTROL',
            payload: { ...control, riskId }
          });

    // Optionally, show a success message
    console.log('Control discarded successfully');

  } catch (error) {
    console.error('Error discarding control:', error);
    // Optionally, handle the error (e.g., show an error message)
  }
};

// --- KEEP all your existing imports and action types above ---

/* ------------------------------------------------------------------
   fetchActionPlan
   ------------------------------------------------------------------
   • Builds a detailed `risks` array.  For each risk we include:
       riskId, riskName, category, priority, sectionName,
       riskSource { name, value[], causes }
   • Builds a causeMap  { "group:value": [riskId,…] } so the backend
     can prioritise root-causes that affect many risks.
   • Sends everything to /.netlify/functions/generateActionPlan
   ------------------------------------------------------------------ */
export const fetchActionPlan = ({
  riskFormData,
  modelId,
  assessmentUuid,
  controlModelType,
  controlModelStage,
  savedControls = []
}) => async (dispatch) => {
  dispatch({ type: FETCH_ACTIONPLAN_START });
  try {
    const res = await fetch('/.netlify/functions/generateActionPlan', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        riskFormData,
        modelId,
        assessmentUuid,
        controlModelType,
        controlModelStage,
        savedControls
      })
    });
    if (!res.ok) throw new Error('Failed to fetch global action plan');
    const data = await res.json();
    dispatch({ type: FETCH_ACTIONPLAN_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: FETCH_ACTIONPLAN_ERROR, payload: err.message });
  }
};
